import { ChapterItem } from "./ChapterItem";

export const ChapterList = ({
  chapters,
  currentTrack,
  isPlaying,
  currentTime,
  duration,
  completedKeys,
  durations,
  queueKeys,
  onPlayVariant,
  onToggleQueue,
}) => {
  if (chapters.length === 0) {
    return (
      <p className="text-center text-white/40 text-sm italic py-10">
        No hay audios disponibles.
      </p>
    );
  }

  return (
    <div className="flex flex-col gap-2">
      {chapters.map((chapter, index) => {
        const isChapterActive = currentTrack?.chapterId === chapter.id;

        const resumenKey = chapter.variants.resumen ? `${chapter.id}-resumen` : null;
        const completoKey = chapter.variants.completo ? `${chapter.id}-completo` : null;
        const anyCompleted =
          (resumenKey && completedKeys.has(resumenKey)) || (completoKey && completedKeys.has(completoKey));

        const progressPercent = isChapterActive
          ? duration > 0
            ? (currentTime / duration) * 100
            : 0
          : anyCompleted
            ? 100
            : 0;

        return (
          <ChapterItem
            key={chapter.id}
            chapter={chapter}
            index={index}
            currentTrack={currentTrack}
            isPlaying={isPlaying}
            progressPercent={progressPercent}
            durations={durations}
            queueKeys={queueKeys}
            onPlayVariant={onPlayVariant}
            onToggleQueue={onToggleQueue}
          />
        );
      })}
    </div>
  );
};
